import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-step-timeline',
  templateUrl: './step-timeline.component.html',
  styleUrls: ['./step-timeline.component.scss']
})



export class StepTimelineComponent implements OnInit {

  @Input() hideStep = false

  @Input() itens: Array<string> = [];
  @Input() itemActive!: number;

  constructor() { }

  ngOnInit() {
  }

}
